<template>
  <div :class="$style.header">
    <slot />
  </div>
</template>

<style module>
.header {
  position: relative;
  margin-left: -22px;
  margin-right: -22px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  height: 90px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: var(--color-grey1);
}
</style>
